import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import AddFrequency from './add_frequencies';
import DeleteConfirmation from './modals/confirmation';
import { useAuth } from '../../providers/auth_provider';
import { formatDate } from '../../utils/format_date';
import { useDebounce } from '../../utils/debouncing-function';

export default function Frequencies() {
    const { token } = useAuth();
    const [frequencies, setFrequencies] = useState([]);
    const [categories, setCategories] = useState([]);
    const [searchCategory, setSearchCategory] = useState('');
    const [subscriptionType, setSubscriptionType] = useState('');
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10);
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [searchName, setSearchName] = useState('');
    const [loading, setLoading] = useState(false);
    const [deltaCategoriesModalOpen, setDeltaCategoriesModalOpen] = useState(false);

    const navigate = useNavigate();
    const handleNavigate = (frequency_id) => {
        navigate('/frequencies/view', { state: { frequency_id } });
    };

    // Debounce the search term
    const debouncedSearchTerm = useDebounce(searchName, 300);

    useEffect(() => {
        fetchCategories();
        fetchFrequencies(currentPage)
    }, [currentPage, debouncedSearchTerm, limit, searchCategory, subscriptionType]);


    const fetchFrequencies = async (page) => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/frequency/get/frequencies?page=${page}&limit=${limit}&search=${searchName}&category_id=${searchCategory}&subscription_type=${subscriptionType}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            setFrequencies(response.data.frequencies);
            setPagination(response.data.pagination);
        } catch (error) {
            console.error('Error fetching frequencies:', error);
        } finally {
            setLoading(false);
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/category/all`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            })
            setCategories(response.data.categories);
        } catch (error) {
            console.log("Errror", error);
        }
    }

    // Handle immediate input changes
    const handleSearchChange = (e) => {
        setSearchName(e.target.value);
    };


    return (
        <>
            <Helmet>
                <title>Manage Frequencies - Enervybe</title>
            </Helmet>
            {/* Frequencies List Table */}

            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Music Upload Required</h2>
                        <p>For a better experience, please upload some music.</p>
                        <button onClick={() => setShowModal(false)}>Close</button>
                    </div>
                </div>
            )}

            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">

                        <h5 className="card-title">Frequencies List</h5>
                        <div className='d-flex gap-4'>
                            <button
                                onClick={() => setDeltaCategoriesModalOpen(true)}
                                className="btn btn-sm btn-label-primary waves-effect waves-light">
                                <span className="d-none d-sm-inline-block">Delta Categories</span>
                            </button>
                            <button
                                className="btn btn-sm btn-label-primary waves-effect waves-light"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasAddFrequency">
                                <i className='ri-add-line d-none d-sm-inline-block me-2'></i>
                                <i className="ri-add-line me-0 me-sm-1 d-inline-block d-sm-none" />
                                <span className="d-none d-sm-inline-block">Add New Frequency</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-datatable text-nowrap">
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="d-flex justify-content-between px-5">
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <input
                                    type="search"
                                    className="form-control form-control-sm"
                                    placeholder="Search Frequency"
                                    aria-controls="DataTables_Table_0"
                                    value={searchName}
                                    onChange={handleSearchChange}  // Direct change handler, not debounced function
                                />
                            </div>
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <select
                                    name="DataTables_Table_0_length"
                                    aria-controls="DataTables_Table_0"
                                    className="form-select form-select-sm"
                                    value={limit}
                                    onChange={(e) => setLimit(e.target.value)}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="datatables-ajax table table-bordered dataTable no-footer"
                                id="DataTables_Table_0"
                                aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {/* <th>Title</th> */}
                                        <th>Category</th>
                                        <th>Volume</th>
                                        <th>Subscription Type</th>
                                        <th>Created On</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="odd">
                                        <td></td>
                                        {/* <td>
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder="Search Title"
                                                aria-controls="DataTables_Table_0"
                                                value={searchTitle}
                                                onChange={(e) => setSearchTitle(e.target.value)}
                                            />
                                        </td> */}
                                        <td>
                                            <label>
                                                <select
                                                    name="DataTables_Table_0_length"
                                                    aria-controls="DataTables_Table_0"
                                                    className="form-select form-select-sm text-capitalize"
                                                    value={searchCategory}
                                                    onChange={(e) => setSearchCategory(e.target.value)}>
                                                    <option value={""}>All</option>
                                                    {categories?.map((cat, index) => (
                                                        <option className="text-capitalize" value={cat.id}>{cat.name}</option>
                                                    ))}
                                                </select>
                                            </label>
                                        </td>
                                        <td></td>
                                        <td>
                                            <div>
                                                <label>
                                                    <select
                                                        name="DataTables_Table_0_length"
                                                        aria-controls="DataTables_Table_0"
                                                        className="form-select form-select-sm"
                                                        value={subscriptionType}
                                                        onChange={(e) => setSubscriptionType(e.target.value)}>
                                                        <option value={""}>All</option>
                                                        <option value={"free"}>Free</option>
                                                        <option value={"paid"}>Paid</option>
                                                    </select>
                                                </label>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={8} className="h-100 text-center">
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : frequencies && frequencies.length > 0 ? (
                                        frequencies.map((frequency, index) => (
                                            <tr className="odd" key={frequency.id}>
                                                <td>{index + 1}</td>
                                                <td>{frequency.category.name}</td>
                                                <td className='text-capitalize'>
                                                    <span>{frequency.frequency_volume}%</span>
                                                    <input type="range" className="form-range d-block" value={frequency.frequency_volume} readOnly />
                                                </td>
                                                <td className='text-capitalize'>
                                                    <div className="btn text-capitalize lh-xs">
                                                        {frequency.subscription_type}
                                                    </div>
                                                </td>
                                                <td>
                                                    {formatDate(frequency.created_at)}
                                                </td>
                                                <td>
                                                    <button className='btn text-primary' onClick={() => handleNavigate(frequency.id)}>
                                                        View/Edit
                                                    </button>
                                                    <DeleteConfirmation frequency={frequency} fetchFrequencies={fetchFrequencies} />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={8} className="h-100 text-center">
                                                <div>
                                                    <p>No frequencies</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <nav aria-label="Page navigation">
                    <ul className="pagination pagination-sm pt-2">
                        <li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage - 1)}>
                                <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                            </a>
                        </li>
                        {pagination.pages && pagination.pages.map(page => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(page)}>
                                    {page}
                                </a>
                            </li>
                        ))}
                        <li className={`page-item next ${currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage + 1)}>
                                <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                            </a>
                        </li>
                    </ul>
                </nav>
                {/* Offcanvas to add new user */}
                <AddFrequency fetchFrequencies={fetchFrequencies} categories={categories} />
                <DeltaCategoriesModal isOpen={deltaCategoriesModalOpen} onClose={() => setDeltaCategoriesModalOpen(false)} token={token} />
            </div>
        </>
    )
};

const DeltaCategoriesModal = ({ isOpen, onClose, token }) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/category/remaining`, {
                    headers: {
                        Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                        Authorization: `Bearer ${token}`,
                    },
                });
                setCategories(response.data.categories);
            } catch (error) {
                console.error('Error fetching categories:', error);
            } finally {
                setLoading(false);
            }
        };

        if (isOpen) {
            fetchCategories();
        }
    }, [isOpen, token]);

    return (
        <div
            className={`modal ${isOpen ? 'show' : 'fade'}`}
            id="deltaCategoriesModal"
            tabIndex="-1"
            aria-labelledby="deltaCategoriesModalLabel"
            aria-hidden={!isOpen}
            style={{ display: isOpen ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="deltaCategoriesModalLabel">
                            Categories
                        </h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden"></span>
                                </div>
                            </div>
                        ) : (
                            <div className="list-group">
                                {!categories.length ? (
                                    <p className="text-center">No categories found.</p>
                                ) : (
                                    categories.map(category => (
                                        <button
                                            key={category.id}
                                            type="button"
                                            className="list-group-item list-group-item-action"
                                        >
                                            {category.name}
                                        </button>
                                    ))
                                )}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                            Close
                        </button>
                        <button
                            onClick={onClose}
                            className="btn btn-sm btn-label-primary waves-effect waves-light"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasAddFrequency"
                        >
                            <i className='ri-add-line d-none d-sm-inline-block me-2'></i>
                            <i className="ri-add-line me-0 me-sm-1 d-inline-block d-sm-none" />
                            <span className="d-none d-sm-inline-block">Add New Frequency</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

